export const locale = 'en-CA';
export const numberFormatConfiguration: Intl.NumberFormatOptions = {
  style: 'currency',
  currency: 'CAD',
  minimumFractionDigits: 2,
};
